import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialInput from "../../../components/MaterialInput";
import {
  deleteData,
  fetchData,
  fetchDataById,
  postData,
  putData,
} from "../../Utils/Baseurl";
import Swal from "sweetalert2";
import SimpleTable from "../../../components/SimpleTable";
import { useSnackbar } from "../../../components/SnackbarProvider";
import { useLoading } from "../../../context/loadingcontext";
import { useAuth } from "../../../context/AuthContext";
import CanAccess from "../../../components/permission/CanAccess";

const TeamMaster = () => {
  const { rolePermission } = useAuth();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [list, setList] = useState([]);
  const [pages, setPages] = useState({
    view: false,
    edit: false,
    id: "",
  });
  const [team, setTeam] = useState({
    name: "",
    nameStatus: "unchecked",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { setCirleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();

  //   Fetch All Teams on Mount

  useEffect(() => {
    getTeamList();
  }, []);

  //   Get Team List

  const getTeamList = async () => {
    setIsLoading(true);
    try {
      const response = await fetchData("api/teams/");

      if (response?.status && Array.isArray(response.data)) {
        setList(response.data);
      } else {
        setList([]);
      }
    } catch (error) {
      console.error("Error while fetching team list:", error);

      setList([]);
    } finally {
      setIsLoading(false);
    }
  };

  //   Create or Update Team

  const createTeam = async () => {
    const data = {
      team_name: team.name,
    };

    try {
      let response;
      if (pages.edit) {
        response = await putData(`api/teams/${pages?.id}/`, data);
      } else {
        response = await postData("api/teams/", data);
      }

      if (response.status) {
        showSnackbar(response?.message, "success");
        handleDialogClose();
        getTeamList();
      } else {
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      console.log(error);

      let message = "An unexpected error occurred";

      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }

      showSnackbar(message, "error");
      handleDialogClose();
    }
  };

  //   View Team for Read-Only

  const viewTeam = async (row) => {
    handleDialogOpen();

    setCirleLoading(true);
    setPages({
      view: true,
      edit: false,
    });

    try {
      const response = await fetchDataById(`api/teams/${row}/`);

      if (response.status) {
        setTeam((prev) => ({
          ...prev,
          name: response?.data?.team_name.replace(/_/g, " "),
        }));
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //   Delete Team with Confirmation

  const deleteTeam = async (row) => {
    const result = await Swal.fire({
      title: "Are you sure you want to delete this team?",
      text: "This action is irreversible and cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await deleteData(`api/teams/${row}/`);

        if (response.status) {
          showSnackbar(response?.message, "success");
          getTeamList();
        } else {
          showSnackbar(response?.message, "error");
        }
      } catch (error) {
        let message = "An unexpected error occurred";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
        } else if (error?.message) {
          message = error.message;
        }

        showSnackbar(message, "error");
      }
    }
  };

  //Edit Function call

  const editTeam = async (row) => {
    handleDialogOpen();

    setCirleLoading(true);
    setPages({
      view: false,
      edit: true,
      id: row,
    });
    try {
      const response = await fetchDataById(`api/teams/${row}/`);

      if (response.status) {
        setTeam((prev) => ({
          ...prev,
          name: response?.data?.team_name.replace(/_/g, " "),
          nameStatus: "success",
        }));
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
    } finally {
      setCirleLoading(false);
    }
  };

  //   Handle Input Change
  const handleChange = (e) => {
    const updatedData = { ...team };
    if (e) {
      const descriptionRegex = new RegExp("^([a-zA-Z ]{1,20})$");
      if (descriptionRegex.test(e.target.value?.trim())) {
        updatedData[e.target.name + "Status"] = "success";
      } else {
        updatedData[e.target.name + "Status"] =
          e.target.value === "" ? "unchecked" : "error";
      }
      updatedData[e.target.name] = e.target.value;
    }
    setTeam(updatedData);
  };

  //   Dialog Control Handlers

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setPages({});
    setTeam({});
  };
  //disabledFunction
  const disabledFunction = () => {
    let disabled;

    if (team.nameStatus == "success") {
      disabled = false;
    } else {
      disabled = true;
    }

    return disabled;
  };
  //   Table Column & Row Configuration
  const teamData = {
    columns: [
      {
        key: "names",
        header: "Team Name",
      },
      { header: "ACTION", key: "action" },
    ],
    row: list?.map((item) => ({
      id: item?.id,
      names: item?.team_name.replace(/_/g, " "),
    })),
  };
  // role permission for table
  const actionVisibility = {
    showEdit: CanAccess.can(rolePermission, "Team", "Team Edit"),
    showView: CanAccess.can(rolePermission, "Team", "Team View"),
    showDelete: CanAccess.can(rolePermission, "Team", "Team Delete"),
  };
  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="medium">
            Team Master
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the Team list here.
          </MaterialTypography>
        </Stack>
        {/* <CanAccess module="Team" component="Team Add"> */}
        <MaterialButton
          variant="gradient"
          color="dark"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleDialogOpen}
        >
          Add Team
        </MaterialButton>
        {/* </CanAccess> */}
      </Stack>
      <SimpleTable
        columns={teamData?.columns}
        data={teamData?.row}
        onEdit={editTeam}
        onDelete={deleteTeam}
        onView={viewTeam}
        isLoading={isLoading}
        actionVisibility={actionVisibility}
      />

      <Dialog
        open={dialogOpen}
        onClose={handleDialogClose}
        aria-labelledby="new-employee-dialog-title"
        sx={{
          "& .MuiDialog-paper": {
            width: "600px",
            maxWidth: "90%",
          },
        }}
      >
        <DialogTitle id="new-employee-dialog-title">
          {pages?.view ? "View Team" : pages?.edit ? "Edit Team" : "Add Team"}
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div>
              <MaterialTypography variant="caption" color="text">
                Team <span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <div>
                <MaterialInput
                  name="name"
                  placeholder="Enter Team Name"
                  value={team?.name}
                  onChange={handleChange}
                  error={team.nameStatus === "error"}
                  success={team.nameStatus === "success"}
                  disabled={pages.view}
                />
                {team.nameStatus === "error" && (
                  <FormControl error style={{ marginTop: "0px" }}>
                    <FormHelperText>
                      Please enter only letters and spaces, with a maximum of 20
                      characters
                    </FormHelperText>
                  </FormControl>
                )}
              </div>
            </div>
          </Box>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleDialogClose} color="primary">
            Cancel
          </MaterialButton>
          {!pages?.view && (
            <MaterialButton
              disabled={disabledFunction()}
              onClick={createTeam}
              color="dark"
              variant="contained"
            >
              Save
            </MaterialButton>
          )}
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default TeamMaster;
